import Inputmask from "inputmask";
import {isEqual} from "@/utils/helpers";

const inputMaskDirective = {
    beforeMount: (el, binding) => {
        if (!binding.value) return;
        if (typeof binding.value === 'string') {
            Inputmask(binding.value).mask(el);
        } else {
            Inputmask(binding.value.name, {...binding.value.options}).mask(el);
        }
    },
    updated: (el, binding) => {
        if (!isEqual(binding.value, binding.oldValue)) {
            if (el.inputmask) {
                el.inputmask.remove();
            }

            if (!binding.value) return;

            if (typeof binding.value === 'string') {
                Inputmask(binding.value).mask(el);
            } else {
                Inputmask(binding.value.name, {...binding.value.options}).mask(el);
            }
        }
    }
};

export default inputMaskDirective;